import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { isValidEvent, triggerHotjarEvent } from 'utils/hotjar';

/**
 * Hotjar event handling flow.
 *
 * @description
 * Business requirement:
 * - Trigger a Hotjar event when a user clicks `Abandon settlement` in the ExitProtection modal on the offer page.
 * - After this action the user is redirected to a non-offer page and a survey should be launched automatically.
 *
 * @solution
 * - ExitProtectionModal saves the event name to `sessionStorage` on button interaction.
 * - After redirect this component reads the stored event and triggers it using `triggerHotjarEvent`.
 * - Valid events are defined in the scalable `HOTJAR_EVENTS` object and checked via `isValidEvent`.
 *
 * @remarks
 * The value under each key in HOTJAR_EVENTS corresponds to a Hotjar event name (storing raw events names in `sessionStorage`)
 */

const HotjarGuard = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.includes('offer')) {
      return;
    }
    const event = sessionStorage.getItem('hj_event');
    if (event && isValidEvent(event)) {
      setTimeout(() => {
        triggerHotjarEvent(event);
        sessionStorage.removeItem('hj_event');
      }, 2000);
    }
  }, [pathname]);

  return null;
};

export default HotjarGuard;
